import ArticleDetail from "./componenets";

export default ArticleDetail;